export const INSTITUTE_API_ROUTES = {
    CHECK_INSTITUTE_EXAM_LIMIT: 'institute/checkInstituteExamLimitt'
}
